import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SideNav from "./components/SideNav";
import RequireAuth from "./components/RequireAuth";
import AppErrorBoundary from "./components/AppErrorBoundary";
import Login from "./pages/Login";                  // Login
import Home from "./pages/Home";                    // HOME
import HomePrintList from "./pages/HomePrintList";  // 측정 이력 출력
import Setting from "./pages/Setting";              // 설정
import Customer from "./pages/Customer";            // 고객지원
import NotFound from "./pages/NotFound";
// 2023-03-01 Implementation
import AdminSetting from "./pages_admin/AdminSetting";          // 관리자 설정
import Registration from "./pages_admin/Registration";          // 등록 관리 - 신규 등록
import RegistrationUser from "./pages_admin/RegistrationUser";  // 등록 관리 - 사용자 관리
import Management from "./pages_admin/Management";              // 장비 관리 - 설정 및 관리
import ManagementUser from "./pages_admin/ManagementUser";      // 장비 관리 - 설정 및 관리 [세부 정보 표시]
// 2025-02-07 SEMIQUZ Mobile
import MobileLogin from "./pages_mobile/MobileLogin";
import MobileHome from "./pages_mobile/MobileHome";
import MobileNotFound from "./pages_mobile/MobileNotFound";

// 렌더 외부에서 발생하는 예외(비동기 등)를 클라이언트 오류 API 로 fire-and-forget 보고.
function installGlobalErrorHook() {
  if (window.__semiquzErrorHookInstalled) return;
  window.__semiquzErrorHookInstalled = true;
  const send = (payload) => {
    try {
      fetch('/api/client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* noop */ }
  };
  window.addEventListener('error', (e) => {
    send({
      page: window.location.pathname,
      message: (e && e.message) || 'window.error',
      stack: (e && e.error && e.error.stack ? String(e.error.stack).slice(0, 500) : ''),
      userAgent: navigator.userAgent,
      ts: Date.now(),
    });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e && e.reason;
    send({
      page: window.location.pathname,
      message: (reason && reason.message) || 'unhandledrejection',
      stack: (reason && reason.stack ? String(reason.stack).slice(0, 500) : ''),
      userAgent: navigator.userAgent,
      ts: Date.now(),
    });
  });
}

function App() {
  useEffect(() => { installGlobalErrorHook(); }, []);

  if (window.location.href.includes('/mobile') || window.location.href.includes('/download')) {
    return (
      <AppErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/mobile/*" element={<MobileLogin />} />
            <Route path="/mobile/home" element={<RequireAuth mobile={true}><MobileHome /></RequireAuth>} />
            <Route path="/*" element={<MobileNotFound />} />
          </Routes>
        </BrowserRouter>
      </AppErrorBoundary>
    );
  }
  return (
    <AppErrorBoundary>
      <div className="root-wrap">
        <BrowserRouter>
          <SideNav />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            {/* User (일반 로그인 필요) */}
            <Route path="/Home" element={<RequireAuth><Home /></RequireAuth>} />
            <Route path="/HomePrintList" element={<RequireAuth><HomePrintList /></RequireAuth>} />
            <Route path="/Setting" element={<RequireAuth><Setting /></RequireAuth>} />
            <Route path="/Customer" element={<RequireAuth><Customer /></RequireAuth>} />
            {/* Admin (관리자 필수) */}
            <Route path="/AdminSetting" element={<RequireAuth requireAdmin={true}><AdminSetting /></RequireAuth>} />
            <Route path="/Registration" element={<RequireAuth requireAdmin={true}><Registration /></RequireAuth>} />
            <Route path="/RegistrationUser" element={<RequireAuth requireAdmin={true}><RegistrationUser /></RequireAuth>} />
            <Route path="/Management" element={<RequireAuth requireAdmin={true}><Management /></RequireAuth>} />
            <Route path="/ManagementUser" element={<RequireAuth requireAdmin={true}><ManagementUser /></RequireAuth>} />
            {/* 미매치 경로 (NotFound 는 자체 세션 검사 유지) */}
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AppErrorBoundary>
  );
}

export default App;
